import React from 'react';
import * as S from './SkeletonLoader.styles';
import { SkeletonLoaderProps } from '@/components/SkeletonLoader/SkeletonLoader.types';

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  dataTestId = 'skeleton-loader',
  borderRadius = 4,
  width = '100%',
  height = '15px',
  ...props
}) => {
  const widthValue = typeof width === 'number' ? `${width}px` : width;
  const heightValue = typeof height === 'number' ? `${height}px` : height;

  return (
    <S.Box
      {...props}
      $as={props.as}
      $borderRadius={borderRadius}
      $width={widthValue}
      $height={heightValue}
      data-testid={dataTestId}
      suppressHydrationWarning
    />
  );
};
